import React from 'react';
import { FormattedMessage } from 'react-intl';

import { MultiTextArea, MultiTextAreaProps } from '../multi-text-area/multi-text-area.component';
import useMultiEmailTextArea from './multi-email-text-area.controller';

export interface MultiEmailTextAreaProps extends Omit<MultiTextAreaProps, 'validateValue' | 'validationErrorMessage'> {
    /**
     * Custom email validation regex. If not provided, uses the default email regex.
     */
    customEmailRegex?: RegExp;
}

export const MultiEmailTextArea = (props: MultiEmailTextAreaProps) => {
    const { validateEmail, placeholder } = useMultiEmailTextArea(props);

    return (
        <MultiTextArea
            {...props}
            validateValue={validateEmail}
            errorMessages={{
                duplicate: (
                    <FormattedMessage
                        id='multi-email-text-area.duplicate-email'
                        defaultMessage='This email address has already been added'
                    />
                ),
                invalid: (
                    <FormattedMessage
                        id='multi-email-text-area.invalid-email'
                        defaultMessage='Please enter a valid email address'
                    />
                ),
                required: (
                    <FormattedMessage
                        id='multi-email-text-area.required'
                        defaultMessage='At least one email address is required'
                    />
                ),
                ...props.errorMessages
            }}
            placeholder={placeholder}
        />
    );
};

export default MultiEmailTextArea;
